export interface Logger {
  error(msg: string, error?: Error): void;
  warn(msg: string, error?: Error): void;
}

let _logger: Logger = console;

/**
 * Set the log function used by the net package.
 */
export const setLogger = (logger: Logger) => {
  _logger = logger;
};

export const error = (msg: string, err?: Error) => _logger.error(msg, err);
export const warn = (msg: string, err?: Error) => _logger.warn(msg, err);
